// Admin panel React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import { Link } from "react-router-dom";
import * as React from "react";

// Firestore
import { db } from "../../../firebase"; // Adjust based on your actual folder structure

import { collection, onSnapshot } from "firebase/firestore";

function Data() {
  const [data, setData] = React.useState([]);

  React.useEffect(() => {
    const fetchData = onSnapshot(
      collection(db, "Experiences"), // Note the uppercase "E"
      (snapshot) => {
        const experienceList = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setData(experienceList);
      },
      (error) => {
        console.log("error == ", error);
      }
    );
    return () => {
      fetchData();
    };
  }, []);

  const SR_NO = ({ srNo }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDBox ml={2} lineHeight={1}>
        <MDTypography variant="body2" fontWeight="small">
          {srNo}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  const EXPERIENCE_NAME = ({ name, image }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium" sx={{ textTransform: "capitalize" }}>
          {name}
        </MDTypography>
      </MDBox>
    </MDBox>
  );

  return {
    columns: [
      { Header: "SR NO#", accessor: "srNo", width: "10%", align: "left" },
      { Header: "Name", accessor: "experiences", align: "left" },
      { Header: "Action", accessor: "action", width: "10%", align: "right" },
    ],
    rows: [
      ...data.map((item, index) => ({
        srNo: <SR_NO srNo={index + 1} />,
        experiences: <EXPERIENCE_NAME image={item.image} name={item.id} />,
        action: (
          <Link to={`/admin/experiences/detail/${item.id}`}>
            <MDButton variant="gradient" color="info" size="small">
              Detail
            </MDButton>
          </Link>
        ),
      })),
    ],
  };
}

export default Data;
